import React, { useEffect, useState } from "react";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "../../routes/routes";
import Barchart from "components/chart/BarChart";
import { Col, Row } from "reactstrap";
import { convertirFechaInputFecha } from "utils/generalFunctions";
import Select from "react-select";
import { avantSolarApi } from "api/authApi";
import { useSelector } from "react-redux";
import Alert from "components/alert";
import SpinnerAvantsolar from "components/utils/spinner";
import { tamanioGrafica } from "utils/generalFunctions";
import Footer from "components/Footer/Footer";
import PerfectScrollbar from "perfect-scrollbar";

var ps;

function GraficaEnergiaPeriodo(props) {
  const mainPanel = React.useRef();
  const [datosGrafica, setDatosGrafica] = useState([]);
  const [minimoFecha, setMinimoFecha] = useState(0);
  const [maximoFecha, setMaximoFecha] = useState(0);
  const [fecha2Activada, setFecha2Activada] = useState(true);
  const [listaInversores, setListaInversores] = useState([]);
  const [inversores, setInversores] = useState([]);
  const { jwt } = useSelector((state) => state.auth);
  const { huerta } = useSelector((state) => state.dataApp);
  const [error, setError] = useState(null);
  const [validated, setValidated] = useState(false);
  const [datosGenerales, setDatosGenerales] = useState({
    energiaGenerada: null,
    media: null,
    totalDias: null,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fectchAllInverters();
  }, []);

  React.useEffect(() => {
    ps = new PerfectScrollbar(mainPanel.current);
    document.body.classList.toggle("perfect-scrollbar-on");

    return function cleanup() {
      ps.destroy();
      document.body.classList.toggle("perfect-scrollbar-on");
    };
  });

  const fectchAllInverters = async () => {
    try {
      const response = await avantSolarApi.get(
        `/admins/allInverters?id_huerta=${huerta}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + jwt,
          },
        }
      );

      let data = response.data;

      if (data?.code == 200) {
        setInversores([...data.data]);
      } else {
      }
    } catch (error) {}
  };

  useEffect(() => {
    let listaInversores = [];
    inversores?.forEach((inversor) => {
      listaInversores.push({
        value: inversor.numInversor,
        label: "Inversor" + inversor.numInversor,
      });
    });

    setListaInversores([...listaInversores]);
  }, [inversores]);

  const acivarFecha2 = (event) => {
    let fecha = new Date(event.target.value);
    let fechaMax = new Date(event.target.value);
    fechaMax.setDate(fecha.getDate() + 31);

    setMinimoFecha(convertirFechaInputFecha(fecha.toLocaleDateString()));
    setMaximoFecha(convertirFechaInputFecha(fechaMax.toLocaleDateString()));
    setFecha2Activada(false);
  };

  const handleSubmitForm = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    }

    setValidated(true);

    //Controlar el select múltiple
    let arrayInversores = [];
    if (event.target.inversores.length >= 2) {
      Array.from(event.target.inversores).forEach((inversor) => {
        arrayInversores.push(inversor.value);
      });
    } else {
      arrayInversores.push(event.target.inversores.value);
    }

    let diaFechaIni = event.target.fechaIni.value.substring(8, 10);
    let mesFechaIni = event.target.fechaIni.value.substring(5, 7);
    let anioFechaIni = event.target.fechaIni.value.substring(0, 4);
    let diaFechaFin = event.target.fechaFin.value.substring(8, 10);
    let mesFechaFin = event.target.fechaFin.value.substring(5, 7);
    let anioFechaFin = event.target.fechaFin.value.substring(0, 4);

    let consulta = "";
    arrayInversores.forEach((inversor, i) => {
      consulta = consulta + `&inversor[${i}][NumInversor]=${inversor}`;
    });
    consulta =
      consulta +
      `&fecha_inicio=${anioFechaIni}${mesFechaIni}${diaFechaIni}&fecha_fin=${anioFechaFin}${mesFechaFin}${diaFechaFin}`;

    fetchDatosGrafica(consulta);
  };

  const fetchDatosGrafica = async (consulta) => {
    setError(null);
    setLoading(true);
    try {
      const response = await avantSolarApi.get(
        `/admins/graphicEnergyDate?id_huerta=${huerta}` + consulta,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + jwt,
          },
        }
      );

      let data = response.data;
      setLoading(false);
      if (data?.code == 200) {
        setDatosGrafica([...data.data.datos]);

        let objeto = datosGenerales;
        objeto.totalDias = data.data.totalDias;
        objeto.media = data.data.media;
        objeto.energiaGenerada = data.data.energiaGenerada;

        setDatosGenerales(objeto);
      } else {
        setError(data.message);
      }
    } catch (error) {
      setError(error?.response?.message);
    }
  };

  return (
    <div className="wrapper">
      <Sidebar {...props} routes={routes} />
      <div className="main-panel" ref={mainPanel}>
        <div>
          <DemoNavbar {...props} />
          <div className="p-2">
            {datosGenerales.media != null && (
              <p className="text-center">
                Generados{" "}
                <span className="font-weight-bold">
                  {datosGenerales.energiaGenerada}
                </span>{" "}
                KWh en{" "}
                <span className="font-weight-bold">
                  {datosGenerales.totalDias}
                </span>{" "}
                días{" ("}
                <span className="font-weight-bold">
                  {datosGenerales.media}
                </span>{" "}
                {" KWh/dia)"}
              </p>
            )}
            {loading && <SpinnerAvantsolar></SpinnerAvantsolar>}
            {error && (
              <div style={{ height: `${tamanioGrafica()}px` }}>
                <Alert message={error}></Alert>
              </div>
            )}
            {!error && <Barchart dataGrafica={datosGrafica} />}
            <div>
              <form
                onSubmit={(event) => {
                  handleSubmitForm(event);
                }}
                className="w-100"
              >
                <Row className="w-100 p-0 m-0 mt-5 mt-lg-3">
                  <Col
                    xs={12}
                    xl={5}
                    className="w-100 d-flex justify-content-center justify-content-sm-end align-items-center mt-3"
                  >
                    <label className="d-flex justify-content-center align-items-center w-100">
                      <Select
                        required
                        isMulti
                        menuPlacement="top"
                        name="inversores"
                        options={listaInversores}
                        className="basic-multi-select w-100"
                        classNamePrefix="select"
                      />
                    </label>
                  </Col>
                  <Col
                    xs={12}
                    xl={5}
                    className="w-100 d-flex justify-content-center justify-content-sm-end align-items-center mt-3"
                  >
                    <label className="d-flex justify-content-center align-items-center w-100">
                      <span className="mr-2">Periodo</span>
                      <input
                        required
                        name="fechaIni"
                        onChange={acivarFecha2}
                        className="w-100 p-1 "
                        type="date"
                        max={convertirFechaInputFecha(
                          new Date().toLocaleDateString()
                        )}
                      />
                      <span className="ml-2 mr-2">-</span>
                      <input
                        disabled={fecha2Activada}
                        required
                        name="fechaFin"
                        min={minimoFecha}
                        max={maximoFecha}
                        className="w-100 p-1"
                        type="date"
                      />
                    </label>
                  </Col>
                  <Col
                    xs={12}
                    xl={2}
                    className="w-100 d-flex justify-content-center justify-content-sm-start align-items-center mt-3"
                  >
                    <label>
                      <button className="btn btn-primary ml-2">Enviar</button>
                    </label>
                  </Col>
                </Row>
              </form>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default GraficaEnergiaPeriodo;
